import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={article.image}
          alt={article.imageAlt}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          width="800"
          height="500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
            {article.category}
          </span>
        </div>
        {article.featured && (
          <div className="absolute top-3 right-3">
            <span className="px-2 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              精选
            </span>
          </div>
        )}
      </div>

      <div className="p-4 md:p-5">
        <h3 className="text-base md:text-lg font-heading text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-calendar-line text-xs"></i>
              </div>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-time-line text-xs"></i>
              </div>
              {article.readTime}{t('article.readTime')}
            </span>
          </div>
          <span className="flex items-center gap-1 text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
            {t('button.readMore')}
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </span>
        </div>
      </div>
    </Link>
  );
}